import React from 'react'
import DashboardPanel from "./DashboardPanel";
import { useAuth } from '../../../providers/AuthProvider';


export default class ClientPanel extends DashboardPanel {
    static is_active = true;
    static colClass = "order-5 mb-6 w-full sm:px-3";

    renderPanel() {
        if (this.isDisabled()) {
            return this.renderDisabled()
        }

        if (this.isInactive()) {
            return this.renderInactive()
        }

        const { client_invites_received } = this.context.auth;

        return (
            <div className="talent-dashboard-panel justify-start">
                {this.renderPanelHeader()}

                <div className="flex items-center gap-3">
                    <img
                        src={client_invites_received[0].client.logo_path}
                        alt={`${client_invites_received[0].client.name} logo`}
                        className='h-12'
                    />
                    <p className="text-lg">
                        {client_invites_received[0].client.name}
                    </p>
                </div>

                <JoinMarketplace />
            </div>
        )
    }
}


const JoinMarketplace = () => {
    const { talentUpdate, auth } = useAuth();

    return (
        <div className="mt-auto flex flex-col gap-4">

            <p className="text-bold text-xl">Join Wripple Marketplace?</p>

            <p>You are currently part of the  {auth.client_invites_received[0].client.name} network. Would you also be interested in joining the Wripple marketplace? This would grant you access to view the Wripple job board and submit proposals for matching jobs.</p>

            <button
                type="button"
                className="btn btn-primary ml-auto"
                onClick={async () => {
                    let confirm = await TB.alert('success', 'Join Wripple Marketplace',
                        // "Are you sure you want to join the Wripple Marketplace? You'll need to apply and undergo an interview process for approval by a Talent Team Member",
                        "Are you sure you want to join the Wripple Marketplace? You will gain access to the jobs board to browse open jobs on the market",
                        [{ title: 'Yes, Join' }, { title: 'Cancel' }]
                    );

                    if (!confirm) {
                        return
                    }
                    const response = await talentUpdate({ is_on_talent_marketplace: true });

                    TB.alert('success', 'You are on the Marketplace',
                        'You have successfully joined the Wripple Marketplace. You can now browse the available jobs by clicking on the Jobs tab on the top bar',
                        [{ title: 'Got it' }]
                    );
                }}
            >
                Join Wripple Marketplace
            </button>

        </div>
    )
}
